module.exports = __webpack_public_path__ + "img/task_mission_install_button.fb866e0b.svg";